export enum SCORING_METHOD {
    ANY = -1,
    NONE = 0,
    MATCHPOINTS = 1,
    BUTLER = 2,
    TEAMS = 3,
    COURSE = 4,
}